import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRetryRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M4.4 3.2q1.1 0 1.2 1.2v4L7 7a12.8 12.8 0 1 1-2 15.6 1.2 1.2 0 0 1 2.1-1.2q.7 1 1.6 2a10.4 10.4 0 1 0 0-14.8L7.3 10h4a1.2 1.2 0 1 1 0 2.4H4.3q-1.1 0-1.2-1.2V4.4q0-1.1 1.2-1.2" })
});
export default SvgRetryRegularIcon;
